import { render, staticRenderFns } from "./gpb-chart.vue?vue&type=template&id=e5e103aa&scoped=true&"
import script from "./gpb-chart.vue?vue&type=script&lang=js&"
export * from "./gpb-chart.vue?vue&type=script&lang=js&"
import style0 from "./gpb-chart.vue?vue&type=style&index=0&id=e5e103aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e103aa",
  null
  
)

export default component.exports